<template>
  <div class="page-coupon-rules page-help">
    <div class="page-coupon-bg" :style="{ backgroundColor: colorMap.bgColor }"></div>
    <div class="help-title" :style="{ color: colorMap.titleColor }">
      {{config.title}}
      <div class="page-coupon-line" :style="{ backgroundColor: colorMap.lineColor }"></div>
    </div>
    <div class="help-content" v-if="config.content" :style="{ color: colorMap.contentColor }">
      <dl>
        <dd>
          <ul>
            <li v-for="(item,index) in ruleList" v-html="item" :key="index" ></li>
          </ul>
        </dd>
      </dl>
    </div>
    <div class="help-content" v-else :style="{ color: colorMap.contentColor }" v-html="config.richContent" ></div>
  </div>
</template>

<script>
const colorMap = [{
  bgColor: '#ffffff',
  titleColor: '#000',
  contentColor: '#666',
  lineColor: '#c8c8c8',
}, {
  bgColor: '#E74833',
  titleColor: '#fff',
  contentColor: '#fff',
  lineColor: '#fff',
}];
export default {
  props: ['config'],

  computed: {
    ruleList() {
      const contentStr = this.config.content;
      if (!contentStr) {
        return [];
      }
      return contentStr.split('\n');
    },
    colorMap() {
      try {
        return JSON.parse(this.config.colorChoice);
      } catch (e) {
        return colorMap[0];
      }
    },
  },
};
</script>
<style lang="less" scoped>
  // @import (less) "~@_src/less/main.less";
  .page-coupon-bg{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    pointer-events: none;
    left: 0;
    top: 0;
  }
  .page-coupon-rules{
    /*width: 750/@rem;*/
    box-sizing: border-box;
  }
  .page-coupon-line{
    height: 1px;
    transform: scaleY(.5);
  }
  .page-help {padding:0 15px; font-size:14px; line-height: 1.8}
  .page-help .help-title {padding:13px 0 9px; font-size: 16px; }
  .page-help .help-content {padding:11px 0}
  .page-help dl {padding:5px 0;}
  .page-help dt {font-size:16px;}
  .page-help dd {margin-left:0px; }
  .page-help dd li {
    margin-left:10px;
    list-style:none;
    word-break: break-word;
  }
</style>
